const routes = {
    ARTICULO: {
        add: '/add-articulo',
        composite: '/add-articulo-compuesto',
        editComposite: '/edit-articulo-compuesto',
        import: '/add-articulo-importar',
        deleted: '/articulos-eliminados',
    },
    DEPARTAMENTO: {
        add: '/add-departamento',
        import: '/add-departamento-importar',
        deleted: '/departamentos-eliminados',
    },
    FAMILIA: {
        add: '/add-familia',
        import: '/add-familia-importar',
        deleted: '/familia-eliminada',
    },
    LISTA_PRECIOS: {
        articuloPrecio: '/articulo-precios',
        add: '/add-lista-precio',
        deleted: '/lista-precio-eliminada',
        import: '/add-lista-precio-importar',
    },
    ARTICULO_PRECIOS: {
        add: '/add-articulo-precio',
        deleted: '/articulo-precio-eliminado',
        import: '/add-articulo-precio-importar',
    },
    TENANTS_BACKOFFICE: {
        add: '/backoffice/add-tenant',
        deleted: '/backoffice/tenants-eliminados',
    },
}

export default routes
